<template>
  <div class="candidate account signup-prompt">
    <Conversation
      v-if="isNew"
      v-model="conversation"
      @scroll="$emit('scroll')"
      @done="$emit('done')"
    />
  </div>
</template>

<script>
// Components
import Conversation from '@/components/prompts/Conversation'

// Helpers
import { mapGetters } from 'vuex'

export default {
  components: { Conversation },

  props: { user: Object },

  created() {
    if (!this.isNew) this.$emit('done')
    this.initialize()
  },

  data() {
    return {
      originalUser: JSON.parse(JSON.stringify(this.user)),
    }
  },

  computed: {
    ...mapGetters({
      campaign: 'campaign/model',
      campaignName: 'campaign/name',
    }),

    isNew() {
      if (this.originalUser) return !this.originalUser.email
      return true
    },
  },

  methods: {
    initialize() {
      this.conversation = [
        {
          key: 0,
          next: 1,
          text: 'welcomePrompt01',
          type: 'prompt',
        },
        {
          key: 1,
          next: 2,
          text: 'welcomePrompt02',
          type: 'prompt',
        },
        {
          key: 2,
          next: 3,
          text: 'welcomePrompt03',
          type: 'prompt',
        },
        {
          key: 3,
          buttons: [
            { text: 'Create an account', props: { block: true }, next: 18 },
            { text: 'I have an account', props: { block: true }, next: 13 },
            { text: 'What is Leaply?', next: 4, props: { block: true, flat: true } },
            {
              text: "I'll come back later",
              props: { block: true, flat: true },
              onClick: () => this.$emit('close'),
            },
          ],
          text: 'accountPrompt01',
          type: 'prompt',
        },
        {
          key: 4,
          next: 5,
          text: 'accountResponse01',
          type: 'response',
        },
        {
          key: 5,
          next: 6,
          text: 'explainLeaply01',
          type: 'prompt',
        },
        {
          key: 6,
          next: 7,
          text: 'explainLeaply02',
          type: 'prompt',
        },
        {
          key: 7,
          next: 8,
          text: 'explainLeaply03',
          type: 'prompt',
        },
        {
          key: 8,
          next: 9,
          text: 'explainLeaply04',
          type: 'prompt',
        },
        {
          key: 9,
          buttons: [
            { text: 'No', props: { flat: true }, onClick: this.openChat },
            { text: 'Yes', next: 10 },
          ],
          text: 'explainLeaply05',
          type: 'prompt',
        },
        {
          key: 10,
          next: 11,
          text: 'accountResponse02',
          type: 'response',
        },
        {
          key: 11,
          buttons: [
            { text: 'Create an account', props: { block: true }, next: 18 },
            { text: 'I have an account', props: { block: true }, next: 12 },
            {
              text: "I'll come back later",
              props: { block: true, flat: true },
              onClick: () => this.$emit('close'),
            },
          ],
          text: 'accountPrompt01',
          type: 'prompt',
        },
        {
          key: 12,
          next: 13,
          text: 'accountResponse03',
          type: 'response',
        },
        {
          key: 13,
          text: 'accountPrompt02',
          component: { name: 'Login', props: { preventRedirect: true }, next: 14 },
          type: 'prompt',
        },
        {
          key: 14,
          next: this.campaign && this.campaign.id ? 15 : 17,
          text: 'accountResponse04',
          type: 'response',
        },
        {
          key: 15,
          next: 16,
          text: 'accountPrompt03',
          type: 'prompt',
        },
        {
          key: 16,
          component: { name: 'CampaignEligibilitiesList', next: 17 },
          type: 'prompt',
        },
        {
          key: 17,
          buttons: [
            {
              text: 'Update my profile',
              onClick: () => {
                this.$router.push('/candidate/profile')
                this.$emit('close')
              },
            },
            {
              text: this.campaign ? `View ${this.campaignName}` : 'View Opportunities',
              onClick: () => {
                if (!this.campaign) this.$router.push('/opportunities')
                if (this.campaign) this.$router.push(`/campaign/${this.campaign.slug}`)
                this.$emit('close')
              },
            },
          ],
          text: 'accountPrompt04',
          type: 'prompt',
        },
        {
          key: 18,
          next: 19,
          text: 'accountResponse05',
          type: 'response',
        },
        {
          key: 19,
          next: 20,
          type: 'prompt',
          text: 'accountPrompt05',
          help: {
            html: `
                    <p>Did you know you can use multiple sign up methods?</p>
                    <p>
                    We recommend linking all the accounts you might want to use to avoid creating duplicate
                    accounts later.
                    </p>
                  `,
          },
        },
        {
          key: 20,
          type: 'prompt',
          text: 'accountPrompt06',
          component: { name: 'Register', next: { new: 23, existing: 21 } },
        },
        {
          key: 21,
          next: 22,
          text: 'accountResponse06',
          type: 'response',
        },
        {
          key: 22,
          next: 17,
          type: 'prompt',
          text: 'accountPrompt07',
        },
        {
          key: 23,
          next: 24,
          text: 'accountResponse06',
          type: 'response',
        },
        {
          key: 24,
          next: 25,
          type: 'prompt',
          text: 'accountPrompt08',
        },
        {
          key: 25,
          type: 'prompt',
          text: 'accountPrompt09',
          buttons: [{ text: 'No', props: { flat: true }, next: 26 }, { text: 'Yes', next: 29 }],
        },
        {
          key: 26,
          next: 27,
          text: 'accountResponse07',
          type: 'response',
        },
        {
          key: 27,
          next: 28,
          type: 'prompt',
          text: 'accountPrompt10',
        },
        {
          key: 28,
          type: 'prompt',
          component: { name: 'EmailConfirmation', next: 29 },
        },
        {
          key: 29,
          type: 'prompt',
          text: 'accountPrompt12',
          buttons: [
            {
              text: 'View Privacy Policy',
              props: { flat: true },
              onClick() { window.open('https://about.leap.ly/assets/privacy_policy.pdf', '_blank') },
            },
            {
              text: 'I do',
              onClick() { Vue.$http.post('candidates/accept_terms') },
              next: 30,
            },
          ],
        },
        {
          key: 30,
          type: 'response',
          text: 'accountResponse09',
          last: true,
        },
      ]
    },

    openChat() {
      if (window.CRISP_READY && window.$crisp.is('chat:opened')) return

      window.$crisp.push(['do', 'chat:open'])
      window.$crisp.push([
        'set',
        'message:text',
        ['Hi! I have some questions about Leaply. Can someone help me?'],
      ])
    },
  },
}
</script>
